/* stylelint-disable value-no-vendor-prefix */

import { SerializedStyles, css } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { positionElementFull } from 'src/domains/layouts/styles/Mixin.style';

import { withConfig } from 'src/withConfig';



interface PreMatchWrapperPropsType {

    bgImage?: string;

    variant: DefaultComponentVariantType | null;

}



const renderPreMatchBgImage = (bgImage: string | undefined, variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (bgImage === undefined ) {

        return css`

            &::before {

                background-image: ${theme.star.preMatch.bgColorSecondary};

            }

        `;

    }



    if (variant === DefaultComponentVariantType.TERTIARY) {

        return css`

            &::before {

                background: url(${bgImage}) 50%/cover no-repeat;

            }

            &::after {

                ${positionElementFull};

                background: ${theme.star.unified.preMatch.bgColorSecondary};

                background-position: top center;

                background-size: 100% auto;

                content: '';

                position: absolute;

            }

        `;

    }



    return css`

        &::before {

            background-image: url(${bgImage}), ${theme.star.preMatch.bgColorSecondary};

        }

    `;

};



const setPreMatchWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            gap: 6px;

            flex-flow: column nowrap;

            align-content: center;

            justify-content: center;

            height: 72px;

            @media ${theme.star.mediaQuery.desktop} {

                gap: ${theme.star.gap.medium};

                height: 128px;

            }

        `;

    }

    if (variant === DefaultComponentVariantType.TERTIARY) {

        return css`

            height: 120px;

            padding: ${theme.star.padding.xMedium} ${theme.star.padding.xLarge};

            justify-content: center;

        `;

    }

    return css`

        height: 72px;

        padding: ${theme.star.padding.xMedium} ${theme.star.padding.large} ${theme.star.padding.large};

        @media ${theme.star.mediaQuery.desktop} {

            height: 128px;

        }

    `;

};



const setVersus = (isNFL: boolean = false, variant: DefaultComponentVariantType | null = null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        background: ${theme.star.unified.preMatch.bgColorTertiary};

        border-radius: ${theme.star.radius.circular};

        flex: 0 0 32px;

        width: 32px;

        height: 32px;

        padding: 0 ${theme.star.padding.small};

        &::before {

            content: '${isNFL ? '@': 'VS'}';

            color: ${theme.star.unified.preMatch.txtColor};

        }

    `;

  }



  return  css`

      background: ${theme.star.preMatch.bgColorTertiary};

      border-radius: ${variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.medium: '0'};

      align-items: center;

      display: flex;

      flex: 0 0 24px;

      font-weight: ${theme.star.fontWeight.bold};

      height: 24px;

      justify-content: center;

      margin: 0 8px;

      &::before {

          content: 'V';

          color: ${theme.star.preMatch.txtColor};

          margin-top: 2px;

      }

      @media ${theme.star.mediaQuery.desktop} {

          flex-basis: 48px;

          height: 48px;

          margin: 0 16px;

          &::before {

              font-size: ${theme.star.fontSize.medium};

              line-height: 1.3334;

              margin-top: 4px;

          }

      }

  `;

}



const setPreMatchDate = (variant: DefaultComponentVariantType | null = null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        color: ${theme.star.unified.preMatch.txtColorSecondary};

        position: relative;

        font-size: ${theme.star.fontSize.small};

        font-weight: ${theme.star.fontWeight.regular};

        text-overflow: ellipsis;

        overflow: hidden;

        max-width: 100%;

        white-space: nowrap;

    `;

  }



  return  css`

      ${setPreMatchDateWrapper(variant, theme)}

      color: ${theme.star.preMatch.txtColorSecondary};

      font-size: ${theme.star.fontSize.xSmall};

      font-weight: ${theme.star.fontWeight.medium};

      line-height: 1.2;

      @media ${theme.star.mediaQuery.desktop} {

          font-size: ${theme.star.fontSize.regular};

          font-weight: ${theme.star.fontWeight.regular};

          line-height: 1.5;

      }

  `;

};



/* Background container Pre match */

export const PreMatchWrapper = withConfig(theme => styled('div', { label: 'PreMatchWrapper' })<PreMatchWrapperPropsType>`

    ${({ variant }): SerializedStyles => setPreMatchWrapper(variant, theme)}

    background-color: ${theme.star.preMatch.bgColor};

    display: flex;

    flex-flow: column;

    margin: auto;

    position: relative;

    text-align: center;

    width: 100%;

    z-index: ${theme.star.zIndexGlobal.base};

    &::before {

        ${positionElementFull};

        background-position: top center;

        background-size: 100% auto;

        content: '';

        position: absolute;

        z-index: ${theme.star.zIndexGlobal.below};

    }

    ${({ bgImage, variant }): SerializedStyles => renderPreMatchBgImage(bgImage, variant, theme)};

`);



interface PreMatchDatePropsType {

    variant?: DefaultComponentVariantType | null;

}



const setPreMatchDateWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css``;

    }

    return css`

        margin-bottom: 6px;

        @media ${theme.star.mediaQuery.desktop} {

            margin-bottom: 8px;

        }

    `;

};



export const PreMatchDate = withConfig(theme => styled('time', { label: 'PreMatchDate' })<PreMatchDatePropsType>`

    ${({ variant }): SerializedStyles => setPreMatchDate(variant, theme)};

    display: block;

`);



export const PreMatchTime = withConfig(theme => styled('span', { label: 'PreMatchTime' })`

    position: relative;

    display: inline-block;

    margin-left: 14px;

    &::before {

        background: currentcolor;

        bottom: 2px;

        content: '';

        left: -8px;

        position: absolute;

        top: 2px;

        width: 1px;

    }

    @media ${theme.star.mediaQuery.desktop} {

        &::before {

            bottom: 5px;

            top: 6px;

        }

    }

`);



interface PreMatchDateTimePropsType {

    variant: DefaultComponentVariantType | null;

}





export const PreMatchDateTime = withConfig(theme => styled('time', { label: 'PreMatchDateTime' })<PreMatchDateTimePropsType>`

    color: ${theme.star.preMatch.txtColorSecondary};

    display: flex;

    max-width: 120px;

    height: 100%;

    flex-direction: column;

    justify-content: center;

    align-items: center;

    gap: ${theme.star.gap.medium};

    flex: 1 0 0;

    font-size: ${theme.star.fontSize.medium};

    font-weight: ${theme.star.fontWeight.bold};

    line-height: 1.333;

`);



export const PreMatchParticipants = styled('div', { label: 'PreMatchParticipants' })<{variant?: DefaultComponentVariantType | null}>`

    align-items: center;

    display: flex;

    justify-content: center;

    flex: 1;

    ${({ variant = null }) => variant === DefaultComponentVariantType.TERTIARY ? 'gap: 12px;' : ''};

    z-index: 1;

`;



export const PreMatchParticipantNameWrapper = withConfig(theme => styled('div', { label: 'PreMatchParticipantNameWrapper' })`

    display: flex;

    min-height: 56px;

    flex-direction: column;

    justify-content: center;

    align-items: center;

    gap: ${theme.star.gap.medium};

    flex: 1 0 0;

    align-self: stretch;



    & [class$='EventRowItemLogo'] {

        @media ${theme.star.mediaQuery.tablet} {

            width: 56px;

            height: 56px;

        }

    }



    & [class$='PreMatchParticipantName'] {

        display: -webkit-box;

        -webkit-box-orient: vertical;

        -webkit-line-clamp: 2;

        align-self: stretch;

        font-size: ${theme.star.fontSize.xRegular};

        font-weight: ${theme.star.fontWeight.bold};

        line-height: 1.428;

        text-overflow: ellipsis;

        overflow: hidden;

        text-align: center !important;

        flex: none;



        @media ${theme.star.mediaQuery.desktop} {

            font-size: ${theme.star.fontSize.regular};

            line-height: 1.5;

        }

    }



    [class$='PreMatchOutrightsWrapper'] & {

        gap: ${theme.star.gap.medium};

        & [class$='PreMatchParticipantName'] {

            font-size: ${theme.star.fontSize.medium};

            line-height: ${theme.star.lineHeight[200]};

        }

    }

`);



export const PreMatchOutrightsWrapper = withConfig(theme => styled('div', { label: 'PreMatchOutrightsWrapper' })`

    z-index: ${theme.star.zIndexGlobal.above};



    & [class$='PreMatchDate'] {

        color: ${theme.star.unified.preMatch.txtColorSecondary};

        line-height: ${theme.star.lineHeight[200]};

    }

`);



export const PreMatchParticipantName = withConfig(theme => styled('span', { label: 'PreMatchParticipantName' })`

    color: ${theme.star.preMatch.txtColorTertiary};

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.medium};

    line-height: 1.3334;

    flex: 0 0 calc(100% - 22px);

    text-align: right;



    &:last-of-type {

        text-align: left;

    }

    

    @media ${theme.star.mediaQuery.desktop} {

        font-size: ${theme.star.fontSize.xMedium};

        line-height: 1.2;

        flex-basis: calc(50% - 40px);

    }

`);





interface VersusPropsType {

    variant: DefaultComponentVariantType | null;

}



export const Versus = withConfig(theme => styled('div', { label: 'Versus' })<{ isNFL?: boolean } & VersusPropsType>`

    align-items: center;

    display: flex;

    font-weight: ${theme.star.fontWeight.bold};

    justify-content: center;

    &::before {

        font-size: ${theme.star.fontSize.xRegular};

        line-height: 1.4286;

    }

    ${({isNFL, variant}) => setVersus(isNFL, variant, theme)}

`);

